module.exports = __webpack_public_path__ + "static/ethereum-86c9b9568b9277a388ecde9922c40b45.png";